module.exports = __webpack_public_path__ + "static/Frys_pin-f192154a03ce21c60eeea1a0ef6f4690.png";